import script from "./SearchResults.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchResults.vue?vue&type=script&setup=true&lang=ts"

import "./SearchResults.vue?vue&type=style&index=0&id=7a5b87ba&lang=css"

const __exports__ = script;

export default __exports__